function AmenitiesGrid({ amenities = [] }) {
  const list =
    Array.isArray(amenities) && amenities.length > 0
      ? amenities
      : ["High-speed Wi-Fi", "Free parking", "Fresh linens", "Refreshments", "Climate control", "Storage space"];

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
      {list.map((item) => (
        <div
          key={item}
          className="flex items-center gap-2 rounded-xl border border-gray-200 bg-white px-3 py-2 shadow-sm"
        >
          <span className="text-emerald-500 text-lg">•</span>
          <span className="text-gray-800">{item}</span>
        </div>
      ))}
    </div>
  );
}

export default AmenitiesGrid;
